import { AxiosResponse } from 'axios'
import { IEntityGST } from 'services/core/genericEntityGST'
import { RequestGST } from 'services/Instances'

export const ItensPendentesServices = () => {
    const path = 'RelatorioItensPendentes'

    const getFillCardsByFilterAndChecks = async (body: IRelatorioItensPendentesRequest): Promise<AxiosResponse<IEntityGST<IRelatorioItensPendentesResponse>>> =>
        await RequestGST.patch(`${path}/GetFillCardsRelatorioItensPendentes`, body)

    const getExcelItensPendentesReport = async (body: IRelatorioItensPendentesRequest): Promise<AxiosResponse<IEntityGST<string>>> =>
        await RequestGST.patch(`${path}/GenerateExcelRelatorioItensPendentes`, body)

    return {
        getExcelItensPendentesReport,
        getFillCardsByFilterAndChecks
    }
}

export const itensSegurancaServices = () => {
    const path = "ItensSeguranca"

    const getAllItensSeguranca = async (): Promise<AxiosResponse<IEntityGST<IItensSegurancaEntity[]>>> =>
        await RequestGST.get(`${path}/GetAll`)

    return {
        getAllItensSeguranca
    }
}

export enum EnumDiasPendentes {
    Maior = 0,
    Menor = 1,
    Todos = 2
}

export interface IItensSegurancaEntity {
    idItemSeguranca: number;
    nmItemSeguranca: string;
    dsItemSeguranca: string;
    txLegislacaoItemSeguranca: string;
    flSubItem: boolean;
    checked?: boolean;
}

export interface IRelatorioItensPendentesRequest {
    IdUsuario: number
    enumDiasPendentes: number;
    qtdDias?: number;
    periodoInicio?: Date | string;
    periodoFim?: Date | string;
    contraparteId?: number;
    substitutoId?: number;
    idGerenciaGeralUnidadeGestora?: number;
    idGerenciaUnidadeGestora?: number;
    unidadeGestoraId?: number;
    idsSubcontratadasFornecedor?: number[];
    idsItemSeguranca?: number[];
    tipoDocumentoIds?: number[];
    checkAll?: CheckAll;
}

export interface CheckAll {
    contraparte?: IGeneriCheckAllItem;
    substituto?: IGeneriCheckAllItem;
    empresa?: IGeneriCheckAllItem;
    centro?: IGeneriCheckAllItem;
    fornecedor?: IGeneriCheckAllItem;
    subcontratadaContrato?: IGeneriCheckAllItem;
}

export interface IGeneriCheckAllItem {
    txPesquisa?: string;
    isCheckAll?: boolean;
    itensCheckados?: number[];
}

export interface IPrintRelatorioItemsPendentesRequest
    extends IRelatorioItensPendentesRequest {
    idsItemSeguranca: number[];
}

export interface IRelatorioItensPendentesResponse {
    contraparte?: IGeneriCheckAllItemResponse[],
    substituto?: IGeneriCheckAllItemResponse[],
    empresa?: IGeneriCheckAllItemResponse[],
    centro?: IGeneriCheckAllItemResponse[],
    fornecedor?: IGeneriCheckAllItemResponse[],
    subcontratadaContrato?: IGeneriCheckAllItemResponse[],
    subcontratadaFornecedor?: IGeneriCheckAllItemResponse[]
}

export interface IGeneriCheckAllItemResponse {
    checked: boolean,
    label: string,
    itemId: number
}